/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React,{useEffect,useState,useCallback,useContext} from 'react';
import HeaderContext from '../../Components/Context/HeaderContext';
import { distributorService } from '../../service/distributor.service';
import Filters from './Filters';
import OfferListing from './OfferListing';
import OfferSkeletonCard from './OfferSkeletonCard';
import moment from 'moment';
import './style.css'
import Pagination from '../../Components/Pagination';
import EmptyPage from '../../Components/EmptyPage';

export const Offers  = () =>{
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [error, seterror] = useState(false);
    const [currentpage, setcurrentpage] = useState(1);
    const [paginationLoader, setpaginationLoader] = useState(false)
    const [payloadValue, setpayloadValue] = useState('&sort=created_at+desc');
    const [responsivePopup, setresponsivePopup] = useState(false)
    const [Products, setProduct] = useState({});
    const [yeskey, setYesKey] = useState(true);
    const [sort,setsort]=useState(false);
    const [list, setlist] = useState([]);
    const [dateselected, setdateselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [loading, setloading] = useState(true)
    const [dateToggle, setdateToggle] = useState({
        start_date:false,
        end_date:false
    })
    const handleDateToggle = (key)=>{
        setdateToggle((prevState)=>({
            ...prevState,
            [key]:!dateToggle[key]
        }))
    
    }
    const handleDate=(key,value)=>{
        setfilters((prevState)=>({
            ...prevState,
            [key]:value
        }))
    }
    const handlePageClick =(data) => {
        // setInitialLoad(true);
        const page = data.selected + 1;
        setcurrentpage(page)
    };
    const [sortSelected,setsortSelected]=useState({
        id:4,
        name:'Recent',
        label:'Recent',
        value:'created_at+desc'
    })  
    const [filters, setfilters] = useState({
        offer_type:[],
        start_date:'',
        end_date:'',
    })
    const sortValues=[
        {
            id:1,
            name:'Recent',
            label:'Recent',
            value:'created_at+desc'

        },
        {
            id:3,
            name:'Expiry Date: Closest first',
            label:'Expiry Date: Closest first',
            value:'end_date+asc'
        },
        {
            id:4,
            name:'Expiry Date: Closest last',
            label:'Expiry Date: Closest last',
            value:'end_date+desc'
        },
        {
            id:2,
            name:'Offer Type',
            label:'Offer Type',
            value:'offer_type+asc'
        },
    ]
    const handleErrorMessage = (message)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 1000);
    }

    const handleErrorMessge=()=>{
        handleErrorMessage('Start date and end date both fields are required');
    }          
    const generateUrl = (val) => {
        let final = `&sort=${sortSelected.value}`;
        if(filters.offer_type.length > 0 &&filters.offer_type.length ===1){
            final = `&offer_type=${filters.offer_type[0]}`
        }
        if(dateselected.start_date !=='' &&dateselected.end_date!==''){
            if(moment(dateselected.end_date).diff(moment(dateselected.start_date))>=0){
                final+=`&expiry_range=${moment(dateselected.start_date).format('YYYY-MM-DD')},${moment(dateselected.end_date).format('YYYY-MM-DD')}`
            }else{
                handleErrorMessage('End Date should be greater than or equal to start date');
                return
            }
        }else{
            if(dateselected.start_date !=='' &&dateselected.end_date===''){
                handleErrorMessge();
                return
            }
            if(dateselected.start_date ==='' &&dateselected.end_date!==''){
                handleErrorMessge();
                return
            }    
        }        setpaginationLoader(true)
        setTimeout(() => {
            setpaginationLoader(false)
        }, 1000);
        setcurrentpage(1)
        setpayloadValue(final)
        return final;
    };
    const handleFetch =  useCallback(
        async(payload) => {
            if(!error){
                setloading(true)
                const offer = await distributorService.OffersList(payload!== undefined? payload: payloadValue,currentpage);
                if(offer.error === false){
                    setProduct(offer.data)
                    setlist(offer.data.data.Items);
                    setpaginationLoader(false)
                    setresponsivePopup(false)
                    setloading(false)
                } else {
                    SetErrorMessage(offer.message.message)
                    setcolorValue('red')
                    setpaginationLoader(false)
                    setpayloadValue('&sort=created_at+desc')
                    setTimeout(() => {
                        SetErrorMessage('')
                        setcolorValue('')
                    }, 2000);
                    
                }        
            } 
        },
        [currentpage,payloadValue],
    )

    const handleClear=()=>{
        setfilters({
            offer_type:[],
        });
        setdateselected({
            start_date: '',
            end_date: '',
        })
        setsortSelected({
            id:6,
            name:'Offer Type: low to High',
            label:'Offer Type: low to High',
            value:'offer_type+asc'
        })
        handleFetch('&sort=created_at+desc');
        // generateUrl()
    }
        
    useEffect(() => {
        handleFetch()
    }, [handleFetch])


    return(
        <div className='w-full flex' style={{minHeight:'84vh'}} >
            <div className='xl:w-[78%] w-full xl:ml-[22%] ml-0 p-5' >
                <div className="flex justify-between items-center">
                    <p className="font-semibold text-[#090406] text-xs10">Offers</p>
                    <div className="flex items-center sm:flex-row flex-col">
                        <div className="bg-[#F5F5FA] rounded-md py-2 w-fit px-4 flex items-center cursor-pointer sm:mt-0 mt-2" onClick={()=>setsort(!sort)}>
                            <span className="text-xs font-bold text-[#808285] dropdown-sort" >Sort by</span>
                            <div className="dropdown relative">
                                <button type="button" id="spacial1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-sort flex items-center">
                                    <p className={`text-sm font-semibold text-#555259] pr-1 dropdown-sort-content`}
                                        onClick={()=>setsort(!sort)}><span className="px-1">:</span>{sortSelected.label}</p>
                                    <img src="images/dropdown-filled.svg" alt="icon" className="pl-1"/>
                                </button>
                                <ul className={`dropdown-sort-content sm:w-[250px] w-[201px] absolute top-7 right-0 ${sort?'show':'hidden'} bg-[#FFFFFF] rounded-[10px] shadow-s2 sm:pl-6 pl-2 pr-1 py-3`} aria-labelledby="special1" style={{zIndex:'21'}}>
                                    {sortValues.map((item)=>(
                                        <li className="w-full bg-[#ffffff] pt-1.5" key={item.id} onClick={()=>{
                                            setsortSelected(item);
                                            generateUrl();
                                            setTimeout(() => {
                                                setsort(false);
                                            }, 1000);
                                        }}>
                                            <div className="w-full flex items-center">
                                                <div className="relative checkbox custom-checkbox custom-radio1 flex items-center">
                                                    <input type="radio" id={`checkbox-${item.id}`} name="radiodate" checked={item.value===sortSelected.value} className="cursor-pointer"/>
                                                    <label htmlFor={`checkbox-${item.id}`} className={`sm:text-base text-sm font-noraml text-[#555259] pl-6 high cursor-pointer ${sortSelected.value!==item.value?'font-semibold':'hidden font-normal'}}`}>{item.label}</label>
                                                    <label htmlFor={`checkbox-${item.id}`} className={`sm:text-base text-sm font-semibold text-[#555259] pl-6 low cursor-pointer ${sort && sortSelected.value===item.value?'font-semibold':'hidden font-normal'}`}>{item.label}</label>
                                                </div>
                                            </div>
                                        </li>
                                    ))
                                    }
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="xl:hidden block mt-5">
                    <div className="flex items-center pr-5">
                        <button id ="filtermodalbutton" type="button" data-bs-toggle="modal" data-bs-target="#filtermodal" className="flex items-center" onClick={()=>setresponsivePopup(!responsivePopup)}>
                            <img src="/images/filter.svg" alt="icon" className="cursor-pointer w-3.5 h-3.5" />
                            <p className="sm:text-base text-xs6 font-semibold text-[#808285] cursor-pointer pl-1">Filter</p>
                        </button>
                    </div>
                </div>
                {loading &&<OfferSkeletonCard />}
                {!loading&& <OfferListing list={list} responsivePopup={responsivePopup}/> }
                { !paginationLoader&&list.length>0 &&(
                    <Pagination 
                        handlePageClick={handlePageClick}
                        List={Products}
                        currentPage={currentpage}
                        totalPage={Products?.data?.number_of_pages}/>
                )
                }
                <>{!loading && list.length===0 &&(
                    <EmptyPage tag="no offers"/>
                )}</>
            </div>
            <Filters 
                setfilters={setfilters}
                Filters={filters}
                generateUrl={generateUrl}
                handleClear={handleClear}
                loading={loading}
                dateToggle={dateToggle}
                setdateToggle={setdateToggle}
                handleDateToggle={handleDateToggle}
                handleDate={handleDate}
                dateselected={dateselected}
                setdateselected={setdateselected}
                responsivePopup={responsivePopup}
                setresponsivePopup={setresponsivePopup}
                yeskey={yeskey}/>
            
        </div>   )
}